import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from "framer-motion"
import { zoomIn } from '../../utils/zoomIn'
import Title from '../common/title'

import './custom.css';

const Icon = () => {
  return (
    <div className="icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="86" height="86" viewBox="0 0 86 86" fill="none">
        <g clipPath="url(#clip0_404_5)">
          <mask id="mask0_404_5" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="86" height="86">
            <path d="M86 0H0V86H86V0Z" fill="white" />
          </mask>
          <g mask="url(#mask0_404_5)">
            <path fillRule="evenodd" clipRule="evenodd" d="M21.5 0H0V43H21.5C9.62589 43 0 52.626 0 64.5V86H43V64.5C43 76.374 52.626 86 64.5 86H86V43H64.5C76.374 43 86 33.3741 86 21.5V0H43V21.5C43 9.62589 33.3741 0 21.5 0ZM43 43H21.5C33.3741 43 43 52.626 43 64.5V43ZM43 43V21.5C43 33.3741 52.626 43 64.5 43H43Z" fill="url(#paint0_linear_404_5)" />
          </g>
        </g>
        <defs>
          <linearGradient id="paint0_linear_404_5" x1="43" y1="0" x2="43" y2="86" gradientUnits="userSpaceOnUse">
            <stop stopColor="white" />
            <stop offset="1" stopColor="#1c857c" />
          </linearGradient>
          <clipPath id="clip0_404_5">
            <rect width="86" height="86" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}

const SecurityOne = () => {

  const advantageTypes = [
    {
      id: 1,
      icon: <Icon />,
      advantage_name: "常見合約範本一次免費下載",
      link: "/contract"
    },
    {
      id: 2,
      icon: <Icon />,
      advantage_name: "AI 根據需求編輯合約條款",
      link: "/service-details"
    },
    {
      id: 3,
      icon: <Icon />,
      advantage_name: "由專業律師事務所設計",
      link: "http://www.law-meridian.com/"
    },
  ];

  return (
    <section className="security-area style-2 pt-100 pb-75" style={{ backgroundColor: '#1e5651' }}>
      <div className="container">

        <Title 
          sectionName={"什麼是 DraftLegal?"}
          sectionTitle={"由律師打造的專業法律服務 AI"}
          sectionNameColor="white"
          sectionTitleColor="white"
          sectionNameFontSize="25px"
          sectionTitleFontSize="18px"
          sectionNameFontWeight="500"
          sectionTitleFontWeight="300"
          style={"style-2"}
        />

        <hr 
          style={{
            border: 'none',
            height: '0.08rem',
            background: 'linear-gradient(to right, #1e5651, white, #1e5651)',
            margin: '0px 0px 30px 0px',
            opacity: '0.6'
          }}
        />

        <div className="row justify-content-center" data-cues="fadeIn">

          {advantageTypes.map(({ icon, id, link, advantage_name }) => {
            return (
              <motion.div className="single-security-item-wrapper col-lg-4 col-md-6" key={id}
                initial="offscreen"
                whileInView="onscreen"
                variants={zoomIn(id)}
                viewport={{ once: true, amount: 0.4 }}
              >
                <div className="single-security-item d-flex align-items-center"
                  style={{ minWidth: '70%' }}
                >
                  {icon}
                  <div className="content">
                    <h3 style={{ color:'white', fontWeight: '400' }}>{advantage_name}</h3>

                    {id!==3 && (
                      <Link
                        className="read-more text-decoration-none"
                        to={link}
                        style={{ color: '#c0bfbf' }} // default text color
                        onMouseEnter={(e) => (e.currentTarget.style.color = 'white')}
                        onMouseLeave={(e) => (e.currentTarget.style.color = '#c0bfbf')}
                      >
                        瞭解更多<i className="ri-arrow-right-line"></i>
                      </Link>
                    )}
                    {id === 3 && (
                      <a
                        className="read-more text-decoration-none"
                        href={link}
                        style={{ color: '#c0bfbf' }}
                        onMouseEnter={(e) => (e.currentTarget.style.color = 'white')}
                        onMouseLeave={(e) => (e.currentTarget.style.color = '#c0bfbf')}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        瞭解經兆國際法律事務所<i className="ri-arrow-right-line"></i>
                      </a>
                    )}
                  </div>
                </div>
              </motion.div>
            )
          })}
        </div>

      </div>

      <div className="background-ellipse"></div>
    </section>
  )
}

export default SecurityOne;




